import { LeaderBoard } from "./LeaderBoard";

export const Dashboard = () => {
  return <LeaderBoard />;
};
